import variables from '../variables';
/* eslint-disable */
const MuiDivider = {
  root: {
    backgroundColor: variables.colors.backgroundDark,
  },
};

export default MuiDivider;
